import React from "react";

const ButtonLink = ({ text = "Button Text" }) => {
  return <div className="">{text}</div>;
};

export default ButtonLink;
